import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Fade } from "@mui/material";
import { styled } from "@mui/material/styles";

const Root = styled(Box)(() => ({
  color: "#5E6366",
  fontSize: "14px",
  letterSpacing: "0.25px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  height: "48px",
  paddingLeft: "18px",
  position: "relative",
}));

const UppercaseSpan = styled("span")(() => ({
  textTransform: "uppercase",
}));

interface OcSidebarGroupProps {
  id: string;
  label: string;
  translation: string;
  narrowMenuOpened: boolean;
  narrowMenu: boolean;
}

export const OcSidebarGroup: React.FC<OcSidebarGroupProps> = ({
  id,
  label,
  translation,
  narrowMenuOpened,
  narrowMenu,
}) => {
  const { t } = useTranslation();
  let menuLabel = t(translation) || label;

  return (
    <Root id={id}>
      <Fade in={!narrowMenu || narrowMenuOpened}>
        <Box>
          <UppercaseSpan>{menuLabel}</UppercaseSpan>
        </Box>
      </Fade>
      <Fade in={narrowMenu && !narrowMenuOpened}>
        <Box
          style={{
            position: "absolute",
            width: "24px",
            height: "2px",
            backgroundColor: "#A6ADAF",
            top: 22,
            left: 16,
          }}
        />
      </Fade>
    </Root>
  );
};

export default OcSidebarGroup;
